/*
===============================================================================================================
                                 Copyright 2023-2025, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

import { getStaticCdnPath } from '@/utilities/static-build';

export default function updatePageIcons(instance, options = {}) {
  const defaultOptions = {
    assetSource: 'local',
    remotePath: '',
    useFallback: false,
    fallbackInstance: 'default',
    customExtensions: {},
  };

  const mergedOptions = { ...defaultOptions, ...options };

  let basePath;

  if (mergedOptions.assetSource === 'remote') {
    const remotePath = mergedOptions.remotePath.replace(/\/$/, '');
    basePath = `${remotePath}/assets/1.0`;
  } else if (mergedOptions.assetSource === 'local') {
    basePath = `${getStaticCdnPath()}/icons/${instance}`;
  }

  const faviconElement = document.getElementById('favicon');
  if (faviconElement && basePath) {
    const faviconExt = mergedOptions.customExtensions.favicon || 'ico';
    faviconElement.setAttribute('href', `${basePath}/favicon.${faviconExt}`);
  }

  const icons = [
    'apple-touch-icon',
    'favicon-16x16',
    'favicon-32x32',
    'android-chrome-192x192',
    'android-chrome-512x512',
  ];

  icons.forEach((icon) => {
    const iconElement = document.getElementById(icon);
    if (iconElement) {
      const iconExt = mergedOptions.customExtensions[icon] || 'png';

      const iconPath = `${basePath}/${icon}.${iconExt}`;

      if (mergedOptions.useFallback) {
        iconElement.onerror = function onError() {
          const fallbackPath = `${getStaticCdnPath()}/icons/${mergedOptions.fallbackInstance}/${icon}.${iconExt}`;
          this.setAttribute('href', fallbackPath);
        };
      }

      iconElement.setAttribute('href', iconPath);
    }
  });
}
